import { Component, EventEmitter, Input, Output, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { AddPopupComponent } from '../add-popup/add-popup.component';

@Component({
  selector: 'app-roles-setup-table',
  standalone: true,
  imports: [CommonModule, FormsModule, AddPopupComponent],
  templateUrl: './roles-setup-table.component.html',
  styleUrls: ['./roles-setup-table.component.css']
})
export class RolesSetupTableComponent implements OnChanges, OnInit {
  constructor(private addService: AddService) { }

  @Input() roles: any[] = [];
    @Input() departments:any[] = [];
  @Output() deleteRole = new EventEmitter<any>();
  @Output() editRole = new EventEmitter<any>();
  @Output() roleCreated = new EventEmitter<void>();
  @Input() loading = false;
  isFormVisible = false;
  selectedRoleType = 'Employee';

  roleTitle = '';
  isRoleActive = true;
  isCheckAllSelected = true;

  // main permission toggles
  isTeamEvalSelected = false;
  isTeamManagSelected = false;
  isTeamResignSelected = false;
  isHolidaysSelected = false;
  isMediaSelected = false;
  isLeaveSelected = false;
  isAttendanceSelected = false;
  isEventSelected = false;
  isAccountSelected = false;
  isSettingSelected = false;
  isPayrollSelected = false;
  isEditMode = false;
  editingRoleId: number | null = null;
  showDeleteModal = false;
  selectedRoleId: number | null = null;
  showSkeleton = true;

  // EDIT MODAL
  showEditModal = false;
  selectedRoleData: any = null;
  teamEvalType: 'all' | 'team' | null = null;
  teamManagementType: 'all' | 'team' | null = null;
  teamResignType: 'all' | 'team' | null = null;
  holidayType: 'all' | 'team' | null = null;
  mediaType: 'all' | 'team' | null = null;
  leaveType: 'all' | 'team' | null = null;
  attendanceType: 'all' | 'team' | null = null;
  eventType: 'all' | 'team' | null = null;
  accountType: 'all' | 'team' | null = null;
  settingType: 'all' | 'team' | null = null;
  payrollType: 'all' | 'team' | null = null;

selectedDepartmentId:number | null = null;
selectedDepartments: any[] = [];
selectedDepartmentIds:any[] = [];



  isSaving = false;

  teamEvalPermissions = {
    // checkAll: true,
    viewList: true,
    update: false,
    addNew: false
  };

  teamManagementPermissions = {
    view: false,
    update: false,
    addUser: false,
    createPayroll: false,
    deleteUser: false,
    updateUser: false,
    monthlySalary: false,
    loanView: false,
    loanAccept: false,
    loanReject: false,
    reset2fa:false,
    action2fa:false
  };

  holidaysPermissions = {
    view:false,
    add:false,
    update:false,
    delete:false
  };


  teamResignPermissions = {
    view: false,
    accept: false,
    reject: false
  };

  mediaPermissions = {
    view: false,
    accept: false,
    reject: false
  };
  leavePermissions = {
    view_leave: false,
    accept: false,
    reject: false,
    view_leave_report: false,
    reset_leave: false,
    undo_leave:false,
    update:false
  };
  attendancePermissions = {
    view_attedance: false,
    sheet: false,
    update: false,
    report: false,
    edit: false,
    delete: false
  };
  eventPermissions = {
    view: false,
    add: false,
    edit: false,
    delete: false
  };
  accountPermissions = {
    view: false,
    add: false,
    edit: false,
    delete: false,
    export: false
  };
  settingPermissions = {
    view: false,
    add: false,
    edit: false,
    delete: false
  };
  payrollPermissions = {
    view_summary: false,
    view_monthly: false,
    add: false,
    approve: false,
    release: false,
    detail:false,
    preview:false,
    admin:false
  };
  updateCheckAllStatus() {
    this.isCheckAllSelected =
      this.isTeamEvalSelected &&
      this.isTeamManagSelected &&
      this.isTeamResignSelected &&
      this.isHolidaysSelected &&
      this.isMediaSelected &&
      this.isLeaveSelected &&
      this.isAttendanceSelected &&
      this.isEventSelected &&
      this.isAccountSelected &&
      this.isSettingSelected &&
      this.isPayrollSelected;
  }
  resetAllPermissions() {
    // Reset main toggles
    this.isTeamEvalSelected = false;
    this.isTeamManagSelected = false;
    this.isTeamResignSelected = false;
    this.isHolidaysSelected = false;
    this.isMediaSelected = false;
    this.isLeaveSelected = false;
    this.isAttendanceSelected = false;
    this.isEventSelected = false;
    this.isAccountSelected = false;
    this.isSettingSelected = false;
    this.isCheckAllSelected = false;
    this.isPayrollSelected = false;

    // Reset permission objects
    this.teamEvalPermissions = {
      // checkAll: false,
      viewList: false,
      update: false,
      addNew: false
    };

    this.teamManagementPermissions = {
      view: false,
      update: false,
      addUser: false,
      createPayroll: false,
      deleteUser: false,
      updateUser: false,
      monthlySalary: false,
      loanView: false,
      loanAccept: false,
      loanReject: false,
         reset2fa:false,
    action2fa:false
    };

    this.teamResignPermissions = {
      view: false,
      accept: false,
      reject: false
    };

    this.holidaysPermissions = {
      view:false,
      add:false,
      update:false,
      delete:false
    };

    this.mediaPermissions = {
         view: false,
    accept: false,
    reject: false
    };

    this.leavePermissions = {
      view_leave: false,
      accept: false,
      reject: false,
      view_leave_report: false,
      reset_leave: false,
      undo_leave:false,
      update:false
    };

    this.attendancePermissions = {
     view_attedance: false,
    sheet: false,
    update: false,
    report: false,
    edit: false,
    delete: false
    };

    this.eventPermissions = {
      view: false,
      add: false,
      edit: false,
      delete: false
    };

    this.accountPermissions = {
      view: false,
      add: false,
      edit: false,
      delete: false,
      export: false
    };

    this.settingPermissions = {
      view: false,
      add: false,
      edit: false,
      delete: false
    };
     this.payrollPermissions = {
       view_summary: false,
      view_monthly: false,
      add: false,
      approve: false,
      release: false,
      detail:false,
      preview:false,
      admin:false
    };

    // Reset types
    this.teamEvalType = null;
    this.teamManagementType = null;
    this.teamResignType = null;
    this.holidayType = null;
    this.mediaType = null;
    this.leaveType = null;
    this.attendanceType = null;
    this.eventType = null;
    this.accountType = null;
    this.settingType = null;
    this.payrollType = null
  }
  // toggle view for form
  toggleView() {
    this.isFormVisible = !this.isFormVisible;
    if (!this.isFormVisible) {
      // Reset form when closing
      this.resetForm();
      this.isEditMode = false;
      this.editingRoleId = null;
    } else {
      this.showTableLoader(1000);
    }
  }
  resetForm() {
    this.roleTitle = '';
    this.isRoleActive = true;
    this.selectedRoleType = 'Employee';
    this.resetAllPermissions();
  }
  // ✅ toggle all parent permissions
  toggleAllPermissions() {
    const state = this.isCheckAllSelected;

    this.isTeamEvalSelected = state;
    this.isTeamManagSelected = state;
    this.isTeamResignSelected = state;
    this.isHolidaysSelected = state;
    this.isMediaSelected = state;
    this.isLeaveSelected = state;
    this.isAttendanceSelected = state;
    this.isEventSelected = state;
    this.isAccountSelected = state;
    this.isSettingSelected = state;
    this.isPayrollSelected = state;

    this.toggleTeamEval(state);
    this.toggleTeamManagement(state);
    this.toggleTeamResign(state);
    this.toggleHoliday(state);
    this.toggleMedia(state);
    this.toggleLeave(state);
    this.toggleAttendance(state);
    this.toggleEvent(state);
    this.toggleAccount(state);
    this.toggleSetting(state);
    this.togglePayroll(state);

  }
  ngOnChanges() {
    if (this.loading) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.toggleAllPermissions();
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

  showTableLoader(duration = 800) {
    this.showSkeleton = true;

    const rowCount = this.roles?.length || 2;
    const columnCount = 6; // 👈 match your table columns
    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }
  // ✅ toggle Team Evaluation children
  toggleTeamEval(state: boolean) {
    Object.keys(this.teamEvalPermissions).forEach(key => {
      this.teamEvalPermissions[key as keyof typeof this.teamEvalPermissions] = state;
    });
    this.teamEvalType = state ? 'all' : null;
  }

  toggleTeamManagement(state: boolean) {
    Object.keys(this.teamManagementPermissions).forEach(key => {
      this.teamManagementPermissions[key as keyof typeof this.teamManagementPermissions] = state;
    });
    this.teamManagementType = state ? 'all' : null;
  }

  toggleTeamResign(state: boolean) {
    Object.keys(this.teamResignPermissions).forEach(key => {
      this.teamResignPermissions[key as keyof typeof this.teamResignPermissions] = state;
    });
    this.teamResignType = state ? 'all' : null;
  }

  toggleHoliday(state: boolean) {
    Object.keys(this.holidaysPermissions).forEach(key => {
      this.holidaysPermissions[key as keyof typeof this.holidaysPermissions] = state;
    });
    this.holidayType = state ? 'all' : null;
  }

  toggleMedia(state: boolean) {
    Object.keys(this.mediaPermissions).forEach(key => {
      this.mediaPermissions[key as keyof typeof this.mediaPermissions] = state;
    });
    this.mediaType = state ? 'all' : null;
  }

  toggleLeave(state: boolean) {
    Object.keys(this.leavePermissions).forEach(key => {
      this.leavePermissions[key as keyof typeof this.leavePermissions] = state;
    });
    this.leaveType = state ? 'all' : null;
  }

  toggleAttendance(state: boolean) {
    Object.keys(this.attendancePermissions).forEach(key => {
      this.attendancePermissions[key as keyof typeof this.attendancePermissions] = state;
    });
    this.attendanceType = state ? 'all' : null;
  }

  toggleEvent(state: boolean) {
    Object.keys(this.eventPermissions).forEach(key => {
      this.eventPermissions[key as keyof typeof this.eventPermissions] = state;
    });
    this.eventType = state ? 'all' : null;
  }

  toggleAccount(state: boolean) {
    Object.keys(this.accountPermissions).forEach(key => {
      this.accountPermissions[key as keyof typeof this.accountPermissions] = state;
    });
    this.accountType = state ? 'all' : null;
  }

  toggleSetting(state: boolean) {
    Object.keys(this.settingPermissions).forEach(key => {
      this.settingPermissions[key as keyof typeof this.settingPermissions] = state;
    });
    this.settingType = state ? 'all' : null;
  }
   togglePayroll(state: boolean) {
    Object.keys(this.payrollPermissions).forEach(key => {
      this.payrollPermissions[key as keyof typeof this.payrollPermissions] = state;
    });
    this.payrollType = state ? 'all' : null;
  }
  

  // parent checkbox changes
  onTeamEvalChange() {
    this.toggleTeamEval(this.isTeamEvalSelected);
  }
  onTeamManagementChange() {
    this.toggleTeamManagement(this.isTeamManagSelected);
  }
  onTeamResignChange() {
    this.toggleTeamResign(this.isTeamResignSelected);
  }
  onHolidayChange() {
    this.toggleHoliday(this.isHolidaysSelected);
  }
  onMediaChange() {
    this.toggleMedia(this.isMediaSelected);
  }
  onLeaveChange() {
    this.toggleLeave(this.isLeaveSelected);
  }
  onAttendanceChange() {
    this.toggleAttendance(this.isAttendanceSelected);
  }
  onEventChange() {
    this.toggleEvent(this.isEventSelected);
  }
  onAccountChange() {
    this.toggleAccount(this.isAccountSelected);
  }
  onSettingChange() {
    this.toggleSetting(this.isSettingSelected);
  }
  onPayrollChange(){
    this.togglePayroll(this.isPayrollSelected);
  }


  // role type mapping
  private getRoleTypeForApi(): string {
    if (this.selectedRoleType === 'Admin') return 'Admin';
    if (this.selectedRoleType === 'Team lead' || this.selectedRoleType === 'Team Lead') return 'Team_Lead';
    if (this.selectedRoleType === 'Team Lead + Admin') return 'Admin_AND_Team_Lead';
    return 'Employee';
  }
  async createRole() {
    const roleType = this.getRoleTypeForApi();
    const combinedData = this.buildPermissionsData();
    const isActive = this.isRoleActive ? 1 : 0;
    const dep_ids = this.selectedDepartmentIds;



        if(roleType == 'Admin_AND_Team_Lead'){
          if(dep_ids.length == 0){
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
              title: 'Please Select Department for this role',
              showConfirmButton: false,
              timer: 2000,
            });
          return;
          }
        }


      
    this.isSaving = true;

    try {
      const result: any = await this.addService.addUserrole(
        this.roleTitle.trim(),
        roleType,
        JSON.stringify(combinedData),
        isActive,
        dep_ids

      );

      this.handleResponse(result, 'Created');
    } catch (error) {
      this.handleError(error);
    } finally {
      this.isSaving = false;
    }
  }

  // ✅ FIX: Ensure updateRole sends data correctly
  async updateRole() {
    debugger
    const roleType = this.getRoleTypeForApi();
    const combinedData = this.buildPermissionsData();
    const isActive = this.isRoleActive ? 1 : 0;
    const dep_ids = this.selectedDepartmentIds;

    

         if(roleType == 'Admin_AND_Team_Lead'){
          if(dep_ids.length == 0){
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
              title: 'Please Select Department for this role',
              showConfirmButton: false,
              timer: 2000,
            });
          return;
          }
        }



    this.isSaving = true;

    try {
      // CHECK YOUR SERVICE: Does it expect (id, name, type...) or (dataObject)?
      const result: any = await this.addService.updateUserrole(
        this.roleTitle.trim(),
        roleType,
        JSON.stringify(combinedData),
        isActive,
        dep_ids,
        this.editingRoleId!
      );
      this.handleResponse(result, 'Updated');
    } catch (error) {
      this.handleError(error);
    } finally {
      this.isSaving = false;
    }
  }
  private handleResponse(result: any, action: string) {
    if (result && result.success) {
      Swal.fire({
        iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="image" >',
        title: `User Role ${action} Successfully`,
        showConfirmButton: false,
        timer: 1500,
      });
      this.isFormVisible = false;
      this.resetForm();
      this.isEditMode = false;
      this.editingRoleId = null;
      this.roleCreated.emit();
    } else {
      Swal.fire({
        iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
        title: result && result.message ? result.message : `Failed to ${action.toLowerCase()} role`,
        showConfirmButton: false,
        timer: 3000,
      });
    }
  }
  private handleError(error: any) {
    console.error('API Error:', error);
    Swal.fire({
      iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
      title: 'Something went wrong with the server connection',
      showConfirmButton: false,
      timer: 3000,
    });
  }
  buildPermissionsData() {
    const evaluationSelected = this.isTeamEvalSelected;
    const evaluationobj = {
      evaluation: evaluationSelected,
      data: {
        type: evaluationSelected ? this.teamEvalType : null,
        values: {
          view: evaluationSelected && this.teamEvalPermissions.viewList,
          add: evaluationSelected && this.teamEvalPermissions.addNew,
          update: evaluationSelected && this.teamEvalPermissions.update,
          sendmail: false,
        },
      },
    };

    const managementSelected = this.isTeamManagSelected;
    const managementobj = {
      team_management: managementSelected,
      data: {
        type: managementSelected ? this.teamManagementType : null,
        values: {
          view: managementSelected && this.teamManagementPermissions.view,
          update: managementSelected && this.teamManagementPermissions.update,
          add: managementSelected && this.teamManagementPermissions.addUser,
          create: managementSelected && this.teamManagementPermissions.createPayroll,
          delete: managementSelected && this.teamManagementPermissions.deleteUser,
          monthly_salary: managementSelected && this.teamManagementPermissions.monthlySalary,
          updateUser: managementSelected && this.teamManagementPermissions.updateUser,
          loanView: managementSelected && this.teamManagementPermissions.loanView,
          loanAccept: managementSelected && this.teamManagementPermissions.loanAccept,
          loanReject: managementSelected && this.teamManagementPermissions.loanReject,
          reset2fa:managementSelected && this.teamManagementPermissions.reset2fa,
          action2fa:managementSelected && this.teamManagementPermissions.action2fa,
        },
      },
    };

    const resignSelected = this.isTeamResignSelected;
    const resignobj = {
      resign: resignSelected,
      data: {
        type: resignSelected ? this.teamResignType : null,
        values: {
          view: resignSelected && this.teamResignPermissions.view,
          accept: resignSelected && this.teamResignPermissions.accept,
          reject: resignSelected && this.teamResignPermissions.reject
        },
      },
    };

    const holidaysSelected = this.isHolidaysSelected;
    const holidayobj = {
      holidays: holidaysSelected,
      data: {
        type: holidaysSelected ? this.holidayType : null,
        values: {
          view: holidaysSelected && this.holidaysPermissions.view,
          add: holidaysSelected && this.holidaysPermissions.add,
          update: holidaysSelected && this.holidaysPermissions.update,
          delete: holidaysSelected && this.holidaysPermissions.delete,
        },
      },
    };

    const mediaSelected = this.isMediaSelected;
    const uploadobj = {
      upload_media: mediaSelected,
      data: {
        type: mediaSelected ? this.mediaType : null,
        values: {
          view: mediaSelected && this.mediaPermissions.view,
          accept: mediaSelected && this.mediaPermissions.accept,
          reject: mediaSelected && this.mediaPermissions.reject,
        },
      },
    };

    const leaveSelected = this.isLeaveSelected;
    const leaveobj = {
      leave_management: leaveSelected,
      data: {
        type: leaveSelected ? this.leaveType : null,
        values: {
          view_leave: leaveSelected && this.leavePermissions.view_leave,
          accept: leaveSelected && this.leavePermissions.accept,
          reject: leaveSelected && this.leavePermissions.reject,
          view_leave_report: leaveSelected && this.leavePermissions.view_leave_report,
          reset_leave: leaveSelected && this.leavePermissions.reset_leave,
          undo_leave: leaveSelected && this.leavePermissions.undo_leave,
          update:leaveSelected && this.leavePermissions.update,
        },
      },
    };

    const attendanceSelected = this.isAttendanceSelected;
    const attendanceobj = {
      attentance_management: attendanceSelected,
      data: {
        type: attendanceSelected ? this.attendanceType : null,
        values: {
          view_attedance: attendanceSelected && this.attendancePermissions.view_attedance,
          sheet: attendanceSelected && this.attendancePermissions.sheet,
          update: attendanceSelected && this.attendancePermissions.update,
          report: attendanceSelected && this.attendancePermissions.report,
          edit: attendanceSelected && this.attendancePermissions.edit,
          delete: attendanceSelected && this.attendancePermissions.delete,
        
        },
      },
    };

    const eventSelected = this.isEventSelected;
    const eventobj = {
      event_managment: eventSelected,
      data: {
        type: eventSelected ? this.eventType : null,
        values: {
          view: eventSelected && this.eventPermissions.view,
          add: eventSelected && this.eventPermissions.add,
          edit: eventSelected && this.eventPermissions.edit,
          delete: eventSelected && this.eventPermissions.delete,
        },
      },
    };

    const accountSelected = this.isAccountSelected;
    const accountobj = {
      account_managment: accountSelected,
      data: {
        type: accountSelected ? this.accountType : null,
        values: {
          view: accountSelected && this.accountPermissions.view,
          add: accountSelected && this.accountPermissions.add,
          edit: accountSelected && this.accountPermissions.edit,
          delete: accountSelected && this.accountPermissions.delete,
          export: accountSelected && this.accountPermissions.export,
        },
      },
    };

    const settingSelected = this.isSettingSelected;
    const setting = {
      setting: settingSelected,
      data: {
        type: settingSelected ? this.settingType : null,
        values: {
          view: settingSelected && this.settingPermissions.view,
          add: settingSelected && this.settingPermissions.add,
          edit: settingSelected && this.settingPermissions.edit,
          delete: settingSelected && this.settingPermissions.delete,
        },
      },
    };


    const payrollSelected = this.isPayrollSelected;
    const payroll = {
      payroll: payrollSelected,
      data: {
        type: payrollSelected ? this.payrollType : null,
        values: {
          view_summary: payrollSelected && this.payrollPermissions.view_summary,
          view_monthly: payrollSelected && this.payrollPermissions.view_monthly,
          add: payrollSelected && this.payrollPermissions.add,
          approve: payrollSelected && this.payrollPermissions.approve,
          release: payrollSelected && this.payrollPermissions.release,
          detail: payrollSelected && this.payrollPermissions.detail,
          preview:payrollSelected && this.payrollPermissions.preview,
          admin: payrollSelected && this.payrollPermissions.admin
        },
      },
    };
    console.log(payrollSelected, payroll);


    return {
      role_type: this.getRoleTypeForApi(),
      team_evaluation: evaluationobj,
      team_managment: managementobj,
      resign_data: resignobj,
      holdays_data: holidayobj,
      upload_data: uploadobj,
      leave_data: leaveobj,
      attendance_data: attendanceobj,
      event_data: eventobj,
      account_data: accountobj,
      settings: setting,
      payroll: payroll,

    };
  }
  // save role
  onSave() {
    if (!this.roleTitle || !this.roleTitle.trim()) {
      Swal.fire({
        iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="image" >',
        title: 'Role title is required',
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    if (this.isEditMode) {
       this.updateRole();
    } else {
       this.createRole();
    }
  }

  openDeleteModal(id: number) {
    this.selectedRoleId = id;
    this.showDeleteModal = true;
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.selectedRoleId = null;
  }

  confirmDelete() {
    if (this.selectedRoleId !== null) {
      this.deleteRole.emit(this.selectedRoleId);
    }
    this.closeDeleteModal();
  }

  openEditModal(role: any) {
    this.selectedRoleData = role;
    this.showEditModal = true;
  }

  closeEditModal() {
    this.showEditModal = false;
    this.selectedRoleData = null;
  }

  confirmEdit() {
    this.editRole.emit(this.selectedRoleData);
    this.closeEditModal();
  }
  loadPermissionsFromData(data: any) {
    // Load Team Evaluation
    if (data.team_evaluation) {
      this.isTeamEvalSelected = data.team_evaluation.evaluation || false;
      if (data.team_evaluation.data) {
        this.teamEvalType = data.team_evaluation.data.type;
        if (data.team_evaluation.data.values) {
          this.teamEvalPermissions = {
            // checkAll: (data.team_evaluation.data.values.view &&
            //   data.team_evaluation.data.values.add &&
            //   data.team_evaluation.data.values.update) || false,
            viewList: data.team_evaluation.data.values.view || false,
            update: data.team_evaluation.data.values.update || false,
            addNew: data.team_evaluation.data.values.add || false
          };
        }
      }
    }

    // Load Team Management
    if (data.team_managment) {
      this.isTeamManagSelected = data.team_managment.team_management || false;
      if (data.team_managment.data) {
        this.teamManagementType = data.team_managment.data.type;
        if (data.team_managment.data.values) {
          this.teamManagementPermissions = {
            view: data.team_managment.data.values.view || false,
            update: data.team_managment.data.values.update || false,
            addUser: data.team_managment.data.values.add || false,
            createPayroll: data.team_managment.data.values.create || false,
            deleteUser: data.team_managment.data.values.delete || false,
            updateUser: data.team_managment.data.values.updateUser || false,
            monthlySalary: data.team_managment.data.values.monthly_salary || false,
            loanView: data.team_managment.data.values.loanView || false,
            loanAccept: data.team_managment.data.values.loanAccept || false,
            loanReject: data.team_managment.data.values.loanReject || false,
            reset2fa: data.team_managment.data.values.reset2fa || false,
            action2fa: data.team_managment.data.values.action2fa || false,
          
          };
        }
      }
    }

    // Load Team Resign
    if (data.resign_data) {
      this.isTeamResignSelected = data.resign_data.resign || false;
      if (data.resign_data.data) {
        this.teamResignType = data.resign_data.data.type;
        if (data.resign_data.data.values) {
          this.teamResignPermissions = {
            view: data.resign_data.data.values.view || false,
            accept: data.resign_data.data.values.accept || false,
            reject: data.resign_data.data.values.reject || false
          };
        }
      }
    }

    // Load Holidays
    if (data.holdays_data) {
      this.isHolidaysSelected = data.holdays_data.holidays || false;
      if (data.holdays_data.data) {
        this.holidayType = data.holdays_data.data.type;
        if (data.holdays_data.data.values) {
          this.holidaysPermissions = {
            view: data.holdays_data.data.values.view || false,
            update: data.holdays_data.data.values.update || false,
            add: data.holdays_data.data.values.add || false,
            delete: data.holdays_data.data.values.delete || false,
          };
        }
      }
    }

    // Load Upload Media
    if (data.upload_data) {
      this.isMediaSelected = data.upload_data.upload_media || false;
      if (data.upload_data.data) {
        this.mediaType = data.upload_data.data.type;
        if (data.upload_data.data.values) {
          this.mediaPermissions = {
            view: data.upload_data.data.values.view || false,
            accept: data.upload_data.data.values.accept || false,
            reject: data.upload_data.data.values.reject || false
          };
        }
      }
    }

    // Load Leave Management
    if (data.leave_data) {
      this.isLeaveSelected = data.leave_data.leave_management || false;
      if (data.leave_data.data) {
        this.leaveType = data.leave_data.data.type;
        if (data.leave_data.data.values) {
          this.leavePermissions = {
            view_leave: data.leave_data.data.values.view_leave || false,
            accept: data.leave_data.data.values.accept || false,
            reject: data.leave_data.data.values.reject || false,
            view_leave_report: data.leave_data.data.values.view_leave_report || false,
            reset_leave: data.leave_data.data.values.reset_leave || false,
            undo_leave: data.leave_data.data.values.undo_leave || false,
            update: data.leave_data.data.values.update || false,
          };
        }
      }
    }

    // Load Attendance Management
    if (data.attendance_data) {
      this.isAttendanceSelected = data.attendance_data.attentance_management || false;
      if (data.attendance_data.data) {
        this.attendanceType = data.attendance_data.data.type;
        if (data.attendance_data.data.values) {
          this.attendancePermissions = {
            view_attedance: data.attendance_data.data.values.view_attedance || false,
            sheet: data.attendance_data.data.values.sheet || false,
            update: data.attendance_data.data.values.update || false,
            report: data.attendance_data.data.values.report || false,
            edit: data.attendance_data.data.values.edit || false,
            delete: data.attendance_data.data.values.delete || false,
        
          };
        }
      }
    }

    // Load Event Management
    if (data.event_data) {
      this.isEventSelected = data.event_data.event_managment || false;
      if (data.event_data.data) {
        this.eventType = data.event_data.data.type;
        if (data.event_data.data.values) {
          this.eventPermissions = {
            view: data.event_data.data.values.view || false,
            add: data.event_data.data.values.add || false,
            edit: data.event_data.data.values.edit || false,
            delete: data.event_data.data.values.delete || false
          };
        }
      }
    }

    // Load Account Management
    if (data.account_data) {
      this.isAccountSelected = data.account_data.account_managment || false;
      if (data.account_data.data) {
        this.accountType = data.account_data.data.type;
        if (data.account_data.data.values) {
          this.accountPermissions = {
            view: data.account_data.data.values.view || false,
            add: data.account_data.data.values.add || false,
            edit: data.account_data.data.values.edit || false,
            delete: data.account_data.data.values.delete || false,
            export: data.account_data.data.values.export || false
          };
        }
      }
    }

    // Load Settings
    if (data.settings) {
      this.isSettingSelected = data.settings.setting || false;
      if (data.settings.data) {
        this.settingType = data.settings.data.type;
        if (data.settings.data.values) {
          this.settingPermissions = {
            view: data.settings.data.values.view || false,
            add: data.settings.data.values.add || false,
            edit: data.settings.data.values.edit || false,
            delete: data.settings.data.values.delete || false
          };
        }
      }
    }
    if (data.payroll) {
      this.isPayrollSelected = data.payroll.payroll || false;
      if (data.payroll.data) {
        this.payrollType = data.payroll.data.type;
        if (data.settings.data.values) {
          this.payrollPermissions = {
              view_summary: data.payroll.data.values.view_summary || false,
              view_monthly: data.payroll.data.values.view_monthly || false,
              add: data.payroll.data.values.add || false,
              approve: data.payroll.data.values.approve || false,
              release: data.payroll.data.values.release || false,
              detail: data.payroll.data.values.detail || false,
              preview:data.payroll.data.values.preview || false,
              admin:data.payroll.data.values.admin || false,

          };
        }
      }
    }

    // Update Check All based on all selections
    this.updateCheckAllStatus();
  }
  openEditForm(role: any) {
    this.isEditMode = true;
    this.editingRoleId = role.id;

    // First, parse the permissions data if it's stored as JSON string
    let permissionsData = {};
    try {
      permissionsData = typeof role.user_roles === 'string'
        ? JSON.parse(role.user_roles)
        : role.parsedUserRoles || role.user_roles || {};
    } catch (e) {
      console.error('Error parsing permissions:', e);
    }

    // Set basic role info
    this.roleTitle = role.role_name;
    this.isRoleActive = role.is_active === 1;
    
    this.selectedDepartments = [];
    this.selectedDepartmentIds = [];

    if (Array.isArray(role.departments)) {
      role.departments.forEach((dep: any) => {

        const id = Number(dep.id);
        if (Number.isNaN(id)) return;

        // avoid duplicates
        if (!this.selectedDepartmentIds.includes(id)) {
          this.selectedDepartments.push(dep);
          this.selectedDepartmentIds.push(id);
        }

      });
    }

    // Map the role type from API format to your component format
    if (role.role_type === 'Admin') {
      this.selectedRoleType = 'Admin';
    } else if (role.role_type === 'Team_Lead') {
      this.selectedRoleType = 'Team lead';
    } else if (role.role_type === 'Admin_AND_Team_Lead') {
      this.selectedRoleType = 'Team Lead + Admin';
    } else {
      this.selectedRoleType = 'Employee';
    }

    // Reset all permissions first
    this.resetAllPermissions();

    // Load permissions data if available
    if (permissionsData) {
      this.loadPermissionsFromData(permissionsData);
    }

    // Show the form
    this.isFormVisible = true;
    this.showTableLoader(1000);
  }


  
onSelect(event: any) {
  const id = +event.target.value;

  const exists = this.selectedDepartments.find(d => d.id === id);
  if (exists) return;
  const dep = this.departments.find(d => d.id === id);
  if (dep) {
    this.selectedDepartments.push(dep);
    this.selectedDepartmentIds = [...this.selectedDepartmentIds, id]
  }
}

remove(id: number) {
  this.selectedDepartments = this.selectedDepartments.filter(d => d.id !== id);
    this.selectedDepartmentIds = this.selectedDepartmentIds.filter(d => d !== id);
}



}